export var EHIDKeyboardKey;
(function (EHIDKeyboardKey) {
    EHIDKeyboardKey[EHIDKeyboardKey["Invalid"] = 0] = "Invalid";
    EHIDKeyboardKey[EHIDKeyboardKey["BeforeFirst"] = 3] = "BeforeFirst";
    EHIDKeyboardKey[EHIDKeyboardKey["A"] = 4] = "A";
    EHIDKeyboardKey[EHIDKeyboardKey["B"] = 5] = "B";
    EHIDKeyboardKey[EHIDKeyboardKey["C"] = 6] = "C";
    EHIDKeyboardKey[EHIDKeyboardKey["D"] = 7] = "D";
    EHIDKeyboardKey[EHIDKeyboardKey["E"] = 8] = "E";
    EHIDKeyboardKey[EHIDKeyboardKey["F"] = 9] = "F";
    EHIDKeyboardKey[EHIDKeyboardKey["G"] = 10] = "G";
    EHIDKeyboardKey[EHIDKeyboardKey["H"] = 11] = "H";
    EHIDKeyboardKey[EHIDKeyboardKey["I"] = 12] = "I";
    EHIDKeyboardKey[EHIDKeyboardKey["J"] = 13] = "J";
    EHIDKeyboardKey[EHIDKeyboardKey["K"] = 14] = "K";
    EHIDKeyboardKey[EHIDKeyboardKey["L"] = 15] = "L";
    EHIDKeyboardKey[EHIDKeyboardKey["M"] = 16] = "M";
    EHIDKeyboardKey[EHIDKeyboardKey["N"] = 17] = "N";
    EHIDKeyboardKey[EHIDKeyboardKey["O"] = 18] = "O";
    EHIDKeyboardKey[EHIDKeyboardKey["P"] = 19] = "P";
    EHIDKeyboardKey[EHIDKeyboardKey["Q"] = 20] = "Q";
    EHIDKeyboardKey[EHIDKeyboardKey["R"] = 21] = "R";
    EHIDKeyboardKey[EHIDKeyboardKey["S"] = 22] = "S";
    EHIDKeyboardKey[EHIDKeyboardKey["T"] = 23] = "T";
    EHIDKeyboardKey[EHIDKeyboardKey["U"] = 24] = "U";
    EHIDKeyboardKey[EHIDKeyboardKey["V"] = 25] = "V";
    EHIDKeyboardKey[EHIDKeyboardKey["W"] = 26] = "W";
    EHIDKeyboardKey[EHIDKeyboardKey["X"] = 27] = "X";
    EHIDKeyboardKey[EHIDKeyboardKey["Y"] = 28] = "Y";
    EHIDKeyboardKey[EHIDKeyboardKey["Z"] = 29] = "Z";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_1"] = 30] = "Key_1";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_2"] = 31] = "Key_2";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_3"] = 32] = "Key_3";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_4"] = 33] = "Key_4";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_5"] = 34] = "Key_5";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_6"] = 35] = "Key_6";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_7"] = 36] = "Key_7";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_8"] = 37] = "Key_8";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_9"] = 38] = "Key_9";
    EHIDKeyboardKey[EHIDKeyboardKey["Key_0"] = 39] = "Key_0";
    EHIDKeyboardKey[EHIDKeyboardKey["Return"] = 40] = "Return";
    EHIDKeyboardKey[EHIDKeyboardKey["Escape"] = 41] = "Escape";
    EHIDKeyboardKey[EHIDKeyboardKey["Backspace"] = 42] = "Backspace";
    EHIDKeyboardKey[EHIDKeyboardKey["Tab"] = 43] = "Tab";
    EHIDKeyboardKey[EHIDKeyboardKey["Space"] = 44] = "Space";
    EHIDKeyboardKey[EHIDKeyboardKey["Dash"] = 45] = "Dash";
    EHIDKeyboardKey[EHIDKeyboardKey["Equals"] = 46] = "Equals";
    EHIDKeyboardKey[EHIDKeyboardKey["LeftBracket"] = 47] = "LeftBracket";
    EHIDKeyboardKey[EHIDKeyboardKey["RightBracket"] = 48] = "RightBracket";
    EHIDKeyboardKey[EHIDKeyboardKey["Backslash"] = 49] = "Backslash";
    EHIDKeyboardKey[EHIDKeyboardKey["Unused1"] = 50] = "Unused1";
    EHIDKeyboardKey[EHIDKeyboardKey["Semicolon"] = 51] = "Semicolon";
    EHIDKeyboardKey[EHIDKeyboardKey["SingleQuote"] = 52] = "SingleQuote";
    EHIDKeyboardKey[EHIDKeyboardKey["Backtick"] = 53] = "Backtick";
    EHIDKeyboardKey[EHIDKeyboardKey["Comma"] = 54] = "Comma";
    EHIDKeyboardKey[EHIDKeyboardKey["Period"] = 55] = "Period";
    EHIDKeyboardKey[EHIDKeyboardKey["ForwardSlash"] = 56] = "ForwardSlash";
    EHIDKeyboardKey[EHIDKeyboardKey["CapsLock"] = 57] = "CapsLock";
    EHIDKeyboardKey[EHIDKeyboardKey["F1"] = 58] = "F1";
    EHIDKeyboardKey[EHIDKeyboardKey["F2"] = 59] = "F2";
    EHIDKeyboardKey[EHIDKeyboardKey["F3"] = 60] = "F3";
    EHIDKeyboardKey[EHIDKeyboardKey["F4"] = 61] = "F4";
    EHIDKeyboardKey[EHIDKeyboardKey["F5"] = 62] = "F5";
    EHIDKeyboardKey[EHIDKeyboardKey["F6"] = 63] = "F6";
    EHIDKeyboardKey[EHIDKeyboardKey["F7"] = 64] = "F7";
    EHIDKeyboardKey[EHIDKeyboardKey["F8"] = 65] = "F8";
    EHIDKeyboardKey[EHIDKeyboardKey["F9"] = 66] = "F9";
    EHIDKeyboardKey[EHIDKeyboardKey["F10"] = 67] = "F10";
    EHIDKeyboardKey[EHIDKeyboardKey["F11"] = 68] = "F11";
    EHIDKeyboardKey[EHIDKeyboardKey["F12"] = 69] = "F12";
    EHIDKeyboardKey[EHIDKeyboardKey["PrintScreen"] = 70] = "PrintScreen";
    EHIDKeyboardKey[EHIDKeyboardKey["ScrollLock"] = 71] = "ScrollLock";
    EHIDKeyboardKey[EHIDKeyboardKey["Break"] = 72] = "Break";
    EHIDKeyboardKey[EHIDKeyboardKey["Insert"] = 73] = "Insert";
    EHIDKeyboardKey[EHIDKeyboardKey["Home"] = 74] = "Home";
    EHIDKeyboardKey[EHIDKeyboardKey["PageUp"] = 75] = "PageUp";
    EHIDKeyboardKey[EHIDKeyboardKey["Delete"] = 76] = "Delete";
    EHIDKeyboardKey[EHIDKeyboardKey["End"] = 77] = "End";
    EHIDKeyboardKey[EHIDKeyboardKey["PageDown"] = 78] = "PageDown";
    EHIDKeyboardKey[EHIDKeyboardKey["RightArrow"] = 79] = "RightArrow";
    EHIDKeyboardKey[EHIDKeyboardKey["LeftArrow"] = 80] = "LeftArrow";
    EHIDKeyboardKey[EHIDKeyboardKey["DownArrow"] = 81] = "DownArrow";
    EHIDKeyboardKey[EHIDKeyboardKey["UpArrow"] = 82] = "UpArrow";
    EHIDKeyboardKey[EHIDKeyboardKey["NumLock"] = 83] = "NumLock";
    EHIDKeyboardKey[EHIDKeyboardKey["KeypadForwardSlash"] = 84] = "KeypadForwardSlash";
    EHIDKeyboardKey[EHIDKeyboardKey["KeypadAsterisk"] = 85] = "KeypadAsterisk";
    EHIDKeyboardKey[EHIDKeyboardKey["KeypadDash"] = 86] = "KeypadDash";
    EHIDKeyboardKey[EHIDKeyboardKey["KeypadPlus"] = 87] = "KeypadPlus";
    EHIDKeyboardKey[EHIDKeyboardKey["KeypadEnter"] = 88] = "KeypadEnter";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_1"] = 89] = "Keypad_1";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_2"] = 90] = "Keypad_2";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_3"] = 91] = "Keypad_3";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_4"] = 92] = "Keypad_4";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_5"] = 93] = "Keypad_5";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_6"] = 94] = "Keypad_6";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_7"] = 95] = "Keypad_7";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_8"] = 96] = "Keypad_8";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_9"] = 97] = "Keypad_9";
    EHIDKeyboardKey[EHIDKeyboardKey["Keypad_0"] = 98] = "Keypad_0";
    EHIDKeyboardKey[EHIDKeyboardKey["KeypadPeriod"] = 99] = "KeypadPeriod";
    EHIDKeyboardKey[EHIDKeyboardKey["LAlt"] = 100] = "LAlt";
    EHIDKeyboardKey[EHIDKeyboardKey["LShift"] = 101] = "LShift";
    EHIDKeyboardKey[EHIDKeyboardKey["LWin"] = 102] = "LWin";
    EHIDKeyboardKey[EHIDKeyboardKey["LControl"] = 103] = "LControl";
    EHIDKeyboardKey[EHIDKeyboardKey["RAlt"] = 104] = "RAlt";
    EHIDKeyboardKey[EHIDKeyboardKey["RShift"] = 105] = "RShift";
    EHIDKeyboardKey[EHIDKeyboardKey["RWin"] = 106] = "RWin";
    EHIDKeyboardKey[EHIDKeyboardKey["RControl"] = 107] = "RControl";
    EHIDKeyboardKey[EHIDKeyboardKey["VolUp"] = 108] = "VolUp";
    EHIDKeyboardKey[EHIDKeyboardKey["VolDown"] = 109] = "VolDown";
    EHIDKeyboardKey[EHIDKeyboardKey["Mute"] = 110] = "Mute";
    EHIDKeyboardKey[EHIDKeyboardKey["Play"] = 111] = "Play";
    EHIDKeyboardKey[EHIDKeyboardKey["Stop"] = 112] = "Stop";
    EHIDKeyboardKey[EHIDKeyboardKey["Next"] = 113] = "Next";
    EHIDKeyboardKey[EHIDKeyboardKey["Prev"] = 114] = "Prev";
    EHIDKeyboardKey[EHIDKeyboardKey["AfterLast"] = 115] = "AfterLast";
})(EHIDKeyboardKey || (EHIDKeyboardKey = {}));
export var EControllerConfigExportType;
(function (EControllerConfigExportType) {
    EControllerConfigExportType[EControllerConfigExportType["Unknown"] = 0] = "Unknown";
    EControllerConfigExportType[EControllerConfigExportType["PersonalLocal"] = 1] = "PersonalLocal";
    EControllerConfigExportType[EControllerConfigExportType["PersonalCloud"] = 2] = "PersonalCloud";
    EControllerConfigExportType[EControllerConfigExportType["Community"] = 3] = "Community";
    EControllerConfigExportType[EControllerConfigExportType["Template"] = 4] = "Template";
    EControllerConfigExportType[EControllerConfigExportType["Official"] = 5] = "Official";
    EControllerConfigExportType[EControllerConfigExportType["OfficialDefault"] = 6] = "OfficialDefault";
})(EControllerConfigExportType || (EControllerConfigExportType = {}));
export var EControllerRumbleSetting;
(function (EControllerRumbleSetting) {
    EControllerRumbleSetting[EControllerRumbleSetting["ControllerPreference"] = 0] = "ControllerPreference";
    EControllerRumbleSetting[EControllerRumbleSetting["Off"] = 1] = "Off";
    EControllerRumbleSetting[EControllerRumbleSetting["On"] = 2] = "On";
})(EControllerRumbleSetting || (EControllerRumbleSetting = {}));
// TODO: Not the actual name, but the enum is only represented in a dropdown
// options vector, ty valve
export var EThirdPartyControllerConfiguration;
(function (EThirdPartyControllerConfiguration) {
    EThirdPartyControllerConfiguration[EThirdPartyControllerConfiguration["Off"] = 0] = "Off";
    EThirdPartyControllerConfiguration[EThirdPartyControllerConfiguration["DefaultSetting"] = 1] = "DefaultSetting";
    EThirdPartyControllerConfiguration[EThirdPartyControllerConfiguration["On"] = 2] = "On";
})(EThirdPartyControllerConfiguration || (EThirdPartyControllerConfiguration = {}));
export var EControllerType;
(function (EControllerType) {
    EControllerType[EControllerType["None"] = -1] = "None";
    EControllerType[EControllerType["Unknown"] = 0] = "Unknown";
    EControllerType[EControllerType["UnknownSteamController"] = 1] = "UnknownSteamController";
    EControllerType[EControllerType["SteamController"] = 2] = "SteamController";
    EControllerType[EControllerType["SteamControllerV2"] = 3] = "SteamControllerV2";
    EControllerType[EControllerType["SteamControllerNeptune"] = 4] = "SteamControllerNeptune";
    EControllerType[EControllerType["FrontPanelBoard"] = 20] = "FrontPanelBoard";
    EControllerType[EControllerType["Generic"] = 30] = "Generic";
    EControllerType[EControllerType["XBox360Controller"] = 31] = "XBox360Controller";
    EControllerType[EControllerType["XBoxOneController"] = 32] = "XBoxOneController";
    EControllerType[EControllerType["PS3Controller"] = 33] = "PS3Controller";
    EControllerType[EControllerType["PS4Controller"] = 34] = "PS4Controller";
    EControllerType[EControllerType["WiiController"] = 35] = "WiiController";
    EControllerType[EControllerType["AppleController"] = 36] = "AppleController";
    EControllerType[EControllerType["AndroidController"] = 37] = "AndroidController";
    EControllerType[EControllerType["SwitchProController"] = 38] = "SwitchProController";
    EControllerType[EControllerType["SwitchJoyConLeft"] = 39] = "SwitchJoyConLeft";
    EControllerType[EControllerType["SwitchJoyConRight"] = 40] = "SwitchJoyConRight";
    EControllerType[EControllerType["SwitchJoyConPair"] = 41] = "SwitchJoyConPair";
    EControllerType[EControllerType["SwitchProGenericInputOnlyController"] = 42] = "SwitchProGenericInputOnlyController";
    EControllerType[EControllerType["MobileTouch"] = 43] = "MobileTouch";
    EControllerType[EControllerType["SwitchProXInputSwitchController"] = 44] = "SwitchProXInputSwitchController";
    EControllerType[EControllerType["PS5Controller"] = 45] = "PS5Controller";
    EControllerType[EControllerType["XboxEliteController"] = 46] = "XboxEliteController";
    EControllerType[EControllerType["LastController"] = 47] = "LastController";
    EControllerType[EControllerType["PS5EdgeController"] = 48] = "PS5EdgeController";
    EControllerType[EControllerType["GenericKeyboard"] = 400] = "GenericKeyboard";
    EControllerType[EControllerType["GenericMouse"] = 800] = "GenericMouse";
})(EControllerType || (EControllerType = {}));
